type Props = {
	className?: string
	size?: number
	color?: string
}

export const CloseIcon = ({ className, size = 16, color = "black" }: Props) => {
	return (
		<svg
			className={className}
			data-testid="closeIcon"
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.14492 14.8574L14.8574 1.14453"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1.14492 1.1446L14.8574 14.8574"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
